import {formatTimeTo} from "../../shared/cards";
import {formatDateTimes} from "../../shared/time-formating";

function handleBuyButton(this: HTMLElement, e: MouseEvent){
    e.preventDefault();
    const width = 1024, height = 720;
    const left = (screen.width - width) / 2, top = (screen.height - height) / 4;

    const el = e.target;
    if (el instanceof HTMLElement){
        const url = el.dataset.href + '&return_to=' + encodeURIComponent(window.location.href);
        const newWindow: Window | null = window.open(url, el.dataset.name,'width=' + width + ',height=' + height + ', top=' + top + ', left=' + left);
        if (newWindow){
            newWindow.focus()
        }
        if (window.dataLayer){
            window.dataLayer.push({
                'event': 'add_to_cart',
                'ecomm_prodid': el.dataset.id,
                'ecomm_pagetype': 'cart',
                'ecomm_totalvalue': el.dataset.price,
                'package_id': el.dataset.id,
                'package_name': el.dataset.name,
                'price': el.dataset.price,
                'site': 'fite'
            })
        }

    }

    return false;
}

document.querySelectorAll<HTMLElement>(".buy-button").forEach((el: HTMLElement) => {
    el.addEventListener("click", handleBuyButton);
})


formatDateTimes();
formatTimeTo();
